export enum MRNMethodTypes {
    AutoGenerate = 1,
    ManualGenerate = 2,
}
